module.exports = __webpack_public_path__ + "static/img/image-placeholder.a5f61a15.svg";